import React from "react";

export default class RoomTopActions extends React.Component {
    constructor( props ) {
        super(props);

    }

    render() {
        return <div className="swipe-screen__top-actions">
            <div className="swipe-screen__top-action  action--rooms"
                 onClick={this.props.onRoomOverviewTap}>

                <div className="icon">

                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g fill="currentColor">
                            <rect width="10.5882" height="10.5882" rx="3"/>
                            <rect y="13.4118" width="10.5882" height="10.5882" rx="3"/>
                            <rect x="13.4119" width="10.5882" height="10.5882" rx="3"/>
                            <rect x="13.4119" y="13.4118" width="10.5882" height="10.5882" rx="3"/>
                        </g>
                    </svg>

                </div>

                <div className="label">
                    Raum <br/>
                    Übersicht
                </div>

            </div>

            {(this.props.showHelp ?? true) &&
            <div className="swipe-screen__top-action  action--help"
                 onClick={this.props.onHelpTap}>
                <div className="icon">
                    <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM12.7969 7.31249C11.9484 7.31249 11.1347 7.64955 10.5347 8.24952C9.93472 8.84949 9.59766 9.66322 9.59766 10.5117C9.59766 10.7541 9.69396 10.9866 9.86538 11.158C10.0368 11.3295 10.2693 11.4258 10.5117 11.4258C10.7541 11.4258 10.9866 11.3295 11.1581 11.158C11.3295 10.9866 11.4258 10.7541 11.4258 10.5117C11.4258 10.2405 11.5062 9.97544 11.6569 9.74997C11.8075 9.52449 12.0216 9.34875 12.2722 9.24498C12.5227 9.1412 12.7984 9.11405 13.0644 9.16696C13.3303 9.21986 13.5746 9.35044 13.7664 9.5422C13.9581 9.73395 14.0887 9.97825 14.1416 10.2442C14.1945 10.5102 14.1674 10.7859 14.0636 11.0364C13.9598 11.2869 13.7841 11.5011 13.5586 11.6517C13.3331 11.8024 13.0681 11.8828 12.7969 11.8828C12.5544 11.8828 12.322 11.9791 12.1505 12.1505C11.9791 12.3219 11.8828 12.5544 11.8828 12.7969V14.625C11.8828 14.8674 11.9791 15.0999 12.1505 15.2713C12.322 15.4427 12.5544 15.539 12.7969 15.539C13.0393 15.539 13.2718 15.4427 13.4432 15.2713C13.6146 15.0999 13.7109 14.8674 13.7109 14.625V13.5647C14.4496 13.349 15.0854 12.8735 15.5011 12.226C15.9169 11.5784 16.0845 10.8024 15.9732 10.041C15.8619 9.27961 15.4791 8.58409 14.8954 8.08267C14.3117 7.58124 13.5664 7.30771 12.7969 7.31249ZM12.7969 18.2812C13.3017 18.2812 13.7109 17.872 13.7109 17.3672C13.7109 16.8624 13.3017 16.4531 12.7969 16.4531C12.2921 16.4531 11.8828 16.8624 11.8828 17.3672C11.8828 17.872 12.2921 18.2812 12.7969 18.2812Z"
                              fill="currentColor"/>
                    </svg>
                </div>
            </div>
            }
        </div>;
    }

}
